import {
    NinchatActions,
    NinchatProperties,
} from '../../../../api/types'
import {AnyAction} from '@reduxjs/toolkit'
import {AttachmentFile} from '../../../../types/ui'


export enum clientActionTypes {
    CALL = 'NINCHAT/CALL',
}

export interface NinchatCallAction {
    payload: NinchatCallActionPayload;
    type: typeof clientActionTypes.CALL;
}

export type NinchatCallActionMeta = {
    caller?: {
        caller_access_key?: NinchatProperties.AccessKey
        caller_auth?: NinchatProperties.IdentityAuth
        caller_id?: NinchatProperties.UserID
        caller_name?: NinchatProperties.IdentityName
        caller_type?: NinchatProperties.CallerIdentityType
    }
    xhr?: {
        method: string;
        type: string;
    };
}

export type NinchatCallActionPayload = {
    header: NinchatActions.NinchatAction;
    payload?: NinchatProperties.PayloadDataFrame[] | AttachmentFile | {
        access_url: string
        identity_name?: NinchatProperties.IdentityName
        identity_type?: NinchatProperties.IdentityType
    };
    meta?: NinchatCallActionMeta;
}

export type NinchatClientActions =
    AnyAction
